import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'

export default function Discover() {
  return (
    <Layout>
      <div className="space-y-8 max-w-6xl mx-auto">
        <PageHeader
          icon="🔍"
          title="Descubrir"
          description="Explora nuevas oportunidades y características en OTD"
        />

        <Section title="Destacados">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { title: 'DeFi Yield', desc: 'Gana intereses en tus activos', icon: '📈' },
              { title: 'Staking', desc: 'Participa en consenso', icon: '🔗' },
              { title: 'NFTs', desc: 'Colecciona activos digitales', icon: '🎨' },
            ].map((item, i) => (
              <Card key={i}>
                <div className="space-y-3">
                  <div className="text-4xl">{item.icon}</div>
                  <h3 className="text-white font-semibold">{item.title}</h3>
                  <p className="text-slate-400 text-sm">{item.desc}</p>
                </div>
              </Card>
            ))}
          </div>
        </Section>

        <Section title="Próximamente">
          <Card>
            <div className="text-center py-8">
              <p className="text-slate-400 text-lg">Más contenido llegando pronto</p>
            </div>
          </Card>
        </Section>
      </div>
    </Layout>
  )
}
